import React, { useState } from "react";
import { withRouter } from 'react-router-dom';

import Button from "../../button/button_v2";
import ModalGeneric from '../../modal/modalGeneric';

import IconPlus from "../../../assets/icons/icon-plus-black.svg";
import IconClose from "../../../assets/icons/icon-close-red.svg";

import * as S from "./styles";

const FrequentQuestions = ({ history,...props }) => {
    const [activeQuestions, setActiveQuestions] = useState([]);
    const [showModalTerms, setShowModalTerms] = useState(false);

    const addModalClose = e => {
        if (showModalTerms === true) {
            setShowModalTerms(false);
        }
    };

    const toggleAnswer = (questionIndex) => {
        setActiveQuestions((prevState) => {
            if (prevState.includes(questionIndex)) {
                return prevState.filter((index) => index !== questionIndex);
            }

            return [...prevState, questionIndex];
        });
    };

    const questions = [
        {
            question: "Como recebo meu cupom exclusivo?",
            answer:
                "Basta clicar no botão “GERAR MEU CUPOM” para aceitar os termos do programa e seu cupom exclusivo será gerado automaticamente e estará disponível para você compartilhar.",
        },
        {
            question: "Quantas pessoas posso indicar?",
            answer:
                "Você pode indicar quantas pessoas desejar. Cada indicação bem-sucedida lhe renderá benefícios.",
        },
        {
            question: "Quando recebo meus benefícios?",
            answer:
                "Os benefícios são creditados na sua conta após a validação do indicado no programa.",
        },
        {
            question: "Posso participar se estiver em um plano gratuito?",
            answer:
                "Sim, você pode participar mesmo estando em um plano gratuito, desde que aceite os termos do programa.",
        },
    ];

    const [modalBlocked, setModalBlocked] = useState(false);
    
    const userPlan = JSON.parse(localStorage.getItem("@userinfo"));
    const getUSerPlan = userPlan.contrato.agro_plan_config.nome_plano;

    const handleRedirect = () => {
        if (getUSerPlan === "TESTE GRÁTIS") {
            setModalBlocked(true);
        } else {
            localStorage.setItem('@loginReload', 'true');
            history.push('/indique-e-ganhe?indique');
        }
    };

    const RedirectPlan = () => {
        history.push('/planos');
    }

    return (
        <S.Container>
            <S.Wrapper>
                <h2>Perguntas Frequentes</h2>

                <S.ContainerQuestionsAndButton>
                    {questions.map((item, index) => (
                        <S.CardQuestion
                            key={index}
                            onClick={() => toggleAnswer(index)}
                        >
                            <S.Question>
                                <p>{item.question}</p>
                                <img
                                    src={
                                        activeQuestions.includes(index)
                                            ? IconClose
                                            : IconPlus
                                    }
                                    alt="Ícone de Mais ou de fechar"
                                />
                            </S.Question>

                            <S.Answer
                                className={
                                    activeQuestions.includes(index) ? "Active" : "Hidden"
                                }
                            >
                                <p>{item.answer}</p>
                            </S.Answer>
                        </S.CardQuestion>
                    ))}

                    <S.ContainerButtonAndTerms>
                        <Button
                            width="206px"
                            height="54.5px"
                            value="GERAR MEU CUPOM"
                            outline={false}
                            disabled={false}
                            loading={false}
                            onClick={handleRedirect}
                        />

                        <p>Ao gerar seu cupom, você aceita os
                            <S.Button onClick={() => setShowModalTerms(true)}>
                                <b>&nbsp; termos do programa</b>
                            </S.Button>
                        </p>
                    </S.ContainerButtonAndTerms>
                </S.ContainerQuestionsAndButton>
            </S.Wrapper>

            <ModalGeneric
                show={showModalTerms}
                onHide={() => addModalClose()}
                size='md'
            >
                <h1>Regulamento Indique e Ganhe</h1>

                <S.ModalContent>
                    <h2>1. Termos e prazo</h2>

                    <S.ModalSectionTerms>
                        <p><strong>1.1.</strong> O presente documento regula o programa <strong>AGRORECEITA INDIQUE E GANHE</strong> promovido pela AGRORECEITA TECNOLOGIA AGRÍCOLA E AMBIENTAL LTDA, pessoa jurídica de direito privado, devidamente inscrita no CNPJ sob o nº 44.098.901/0001-33 e Inscrição Estadual Isenta, situada na Rua Rosa Lotfi de Almeida Bueno nº 155, Vila Nastri II, na cidade de Itapetininga, Estado de São Paulo, CEP 18.206-390, neste ato representada nos termos dos seus documentos societários (“AgroReceita”), bem como a participação dos clientes da AgroReceita no Programa.</p>

                        <S.ModalSectionTermsAndTopics>
                            <p><strong>1.2.</strong> Para fins deste Regulamento, será considerado: </p>

                            <S.ModalTopics>
                                <p><strong>1.2.1.</strong> “Cliente AgroReceita”: a pessoa física ou jurídica com contrato vigente, celebrado com a AgroReceita, cujo objeto são os produtos e/ou serviços oferecidos pela AgroReceita, durante o período de participação no programa,</p>

                                <p><strong>1.2.2.</strong> “Parceiro”: a pessoa física ou jurídica indicada pelo Cliente AgroReceita que, em razão da indicação, vier a celebrar um novo contrato de parceria comercial com a AgroReceita, com o objetivo de prospectar Clientes AgroReceita para a AgroReceita.</p>

                                <p><strong>1.2.3.</strong> “Novo Cliente AgroReceita”: a pessoa física ou jurídica que:</p>

                                <S.ModalSectionTopics>
                                    <p>(i) contratar os Serviços AgroReceita  no prazo de 45 (quarenta e cinco) dias contados da indicação, indicado pelo Cliente AgroReceita; e/ou(ii) contratar os Serviços AgroReceita no prazo de 45 (quarenta e cinco) dias contados da celebração do contrato de parceria comercial entre AgroReceita e o Parceiro.</p>
                                </S.ModalSectionTopics>

                                <p><strong>1.3.</strong> O Programa tem por objetivo conceder descontos a todos os Clientes AgroReceita que indicarem novos clientes que, em razão da indicação do Cliente AgroReceita, tornarem-se um Novo Cliente AgroReceita.</p>

                                <S.ModalSectionTopics>
                                    <p><strong>1.3.1.</strong> As indicações do Cliente AgroReceita poderão ocorrer de forma direta, quando o Cliente AgroReceita indicar o Novo Cliente AgroReceita ou, de forma indireta, quando o Cliente AgroReceita indicar o Parceiro, e o Parceiro indicar o Novo Cliente AgroReceita.</p>
                                </S.ModalSectionTopics>

                                <p><strong>1.4.</strong> O Programa começa a vigorar a partir do dia 15/12/2024 e permanecerá vigente por prazo indeterminado, podendo ser modificado e/ou encerrado pela AgroReceita, a qualquer momento, mediante comunicado através do próprio site, sem a necessidade de aviso prévio aos Clientes AgroReceita. </p>
                            </S.ModalTopics>
                        </S.ModalSectionTermsAndTopics>
                    </S.ModalSectionTerms>

                    <h2>2. Requisitos de participação</h2>

                    <S.ModalSectionTerms>
                        <p><strong>2.1.</strong> A adesão ao Programa é voluntária, válida em todo o território nacional, e implica na aceitação, por parte do Cliente AgroReceita, deste Regulamento e da Política de Privacidade, disponível em <a href="https://agroreceita.com.br/politica-de-privacidade/">https://agroreceita.com.br/politica-de-privacidade/</a>, que constitui parte integrante do presente documento.</p>

                        <S.ModalSubTerms>
                            <p><strong>2.2.</strong> Não poderão participar deste Programa:</p>

                            <S.ModalSectionTopicsList>
                                <ul>
                                    <li>Pessoas físicas menores de 18 (dezoito) anos;</li>

                                    <li>Pessoas não residentes no Brasil;</li>

                                    <li>Aqueles que não sejam Clientes AgroReceita ativos;</li>

                                    <li>Participantes que não cumpram os meios e condições previstos neste Regulamento;</li>

                                    <li>Sócios, diretores, empregados, estagiários e colaboradores da AgroReceita, bem como profissionais de agências de publicidade direta ou indiretamente envolvidas na organização e execução deste programa.</li>
                                </ul>
                            </S.ModalSectionTopicsList>
                        </S.ModalSubTerms>
                    </S.ModalSectionTerms>

                    <h2>3. Processo e recompensa</h2>

                    <S.ModalTopics>
                        <p><strong>3.1.</strong> O Cliente AgroReceita que indicar, seja direta ou indiretamente, um Novo Cliente AgroReceita receberá uma recompensa na forma de desconto na mensalidade, sendo o valor deste desconto variável conforme o valor do contrato celebrado entre o Novo Cliente AgroReceita e a AgroReceita.</p>

                        <p><strong>3.2.</strong> Para realizar a indicação, o Cliente AgroReceita deverá cadastrar o Novo Cliente AgroReceita ou o Parceiro na plataforma "AgroReceita Indique e Ganhe", acessível através do link <a href="https://agroreceita.com.br/indique-e-ganhe">https://agroreceita.com.br/indique-e-ganhe</a>.</p>

                        <p><strong>3.3.</strong> As indicações serão validadas pela AgroReceita antes da liberação do bônus.</p>

                        <p><strong>3.4.</strong> O bônus será concedido pela AgroReceita ao Cliente AgroReceita no mês seguinte ao pagamento da primeira mensalidade ou do pagamento integral do Contrato AgroReceita pelo Novo Cliente AgroReceita.</p>

                        <p><strong>3.5.</strong> O valor do bônus corresponderá a (i) 100% (cem por cento) do valor bruto da primeira mensalidade paga pelo Novo Cliente AgroReceita, ou (ii) 1/12 (um doze avos) do valor total do Contrato AgroReceita, caso o pagamento do contrato seja feito à vista pelo Novo Cliente AgroReceita.</p>

                        <p><strong>3.7.</strong> O Cashback deverá ser utilizado nos estabelecimentos credenciados a aceitar o cartão pré-pago da Social Bank.</p>

                        <p><strong>3.8.</strong> O bônus será limitado ao valor efetivamente pago pelo Cliente AgroReceita à AgroReceita nos últimos 12 (doze) meses em virtude da relação contratual mantida entre as partes.</p>

                        <p><strong>3.9.</strong> Caso o valor do bônus ultrapasse o montante pago pelo Cliente AgroReceita à AgroReceita nos últimos 12 (doze) meses, o valor excedente será registrado no sistema da AgroReceita e poderá ser utilizado pelo Cliente AgroReceita no próximo período contratual, caso o Contrato AgroReceita seja renovado.</p>
                    </S.ModalTopics>

                    <h2>4. Ineligibilidade</h2>

                    <S.ModalTopics>
                        <p><strong>4.1.</strong> Os Clientes AgroReceita que não cumprirem  com as condições deste Regulamento e Clientes AgroReceita que prestarem informações falsas, incompletas ou incorretas e/ou que realizarem qualquer ação fraudulente durante o Programa e não cumprirem todos os critérios estabelecidos neste Regulamento poderão ser excluídos a qualquer momento pela AgroReceita, sem direito ao bônus em nenhuma circunstância.</p>

                        <p><strong>4.2.</strong> A AgroReceita poderá, a seu exclusivo critério, suspender ou excluir os Clientes AgroReceita caso haja suspeitas ou indícios de que o Cliente tenha adotado práticas irregulares, desleais ou que contrariem os objetivos deste Programa.</p>

                        <p><strong>4.3.</strong> Caso ocorra a desclassificação, a AgroReceita informará o Cliente, por e-mail, sobre os motivos que levaram à exclusão do Programa.</p>

                        <p><strong>4.4.</strong> Não será permitido qualquer recurso contra as decisões de desclassificação tomadas pela AgroReceita, conforme previsto neste Regulamento.</p>
                    </S.ModalTopics>

                    <h2>5. Responsabilidades das partes</h2>

                    <S.ModalTopics>
                        <p><strong>5.1.</strong> A AgroReceita não se responsabiliza, sob nenhuma circunstância, por quaisquer danos, sejam patrimoniais ou extrapatrimoniais, sofridos ou causados aos Clientes AgroReceita em decorrência de sua participação no Programa, incluindo qualquer obrigação tributária do Cliente AgroReceita resultante do recebimento do Bônus.</p>

                        <p><strong>5.2.</strong> Os Clientes AgroReceita isentarão ou indenizarão a AgroReceita por todas as perdas e danos de qualquer natureza (inclusive honorários advocatícios), decorrentes do descumprimento de suas obrigações previstas ou relacionadas a este Regulamento.</p>
                    </S.ModalTopics>

                    <h2>6. Disposições finais</h2>

                    <S.ModalTopics>
                        <p><strong>6.1.</strong> A participação no Programa implica na aceitação automática e integral de todas as disposições deste Regulamento, sendo impossível</p>

                        <p><strong>6.2.</strong> Quaisquer dúvidas relacionadas ao Programa Indique e Ganhe poderão ser esclarecidas através do WhatsApp: (15) 98165-7739, de segunda a sexta-feira, das 8h30 às 18h00, horário de Brasília.</p>

                        <p><strong>6.3.</strong> A AgroReceita será responsável por avaliar e decidir sobre qualquer questão não expressamente prevista neste Regulamento, sendo suas decisões finais e irrecorríveis.</p>

                        <p><strong>6.4.</strong> A AgroReceita poderá alterar os termos deste Regulamento, caso haja comprometimento na condução do Programa Indique e Ganhe, com a devida comunicação prévia aos Clientes AgroReceita.</p>

                        <p><strong>6.5.</strong> A legislação brasileira será aplicável à relação entre a AgroReceita e os Clientes AgroReceita, no que se refere à aceitação deste Regulamento e à participação no Programa Indique e Ganhe.</p>

                        <p><strong>6.6.</strong> Este Programa não se enquadra nas modalidades de distribuição gratuita de prêmios previstas na Lei 5.768/1971, no Decreto 70.951 e na Portaria 41/2008, não estando sujeito, portanto, aos seus requisitos, inclusive no que se refere à necessidade de autorização prévia.</p>

                        <p><strong>6.7.</strong> Fica eleito o Foro da cidade de Itapetininga, Estado de São Paulo, para dirimir quaisquer questões oriundas do presente Regulamento, com renúncia a qualquer outro, por mais privilegiado que seja.</p>
                    </S.ModalTopics>

                    <p>Itapetininga, dezembro de 2024</p>

                    <S.Author>
                        <p>Cristina Gonçalves Felipe Spinola</p>
                        
                        <p>CEO da AgroReceita</p>
                    </S.Author>
                </S.ModalContent>
            </ModalGeneric>

                <ModalGeneric
                    show={modalBlocked}
                    onHide={false}
                    >
                    <S.ContainerModalBlocked>
                        <S.ModalBlockedTitle>
                            Essa é uma função exclusiva para clientes AgroReceita
                        </S.ModalBlockedTitle>

                        <S.ModalBlockedDescription>
                            Para não comprometer o controle de suas receitas agronômicas durante o período de teste esta função é bloqueada.
                        </S.ModalBlockedDescription>
                        
                        <S.ModalBlockedDescription>
                            Assine o AgroReceita para desbloquear esta função!
                        </S.ModalBlockedDescription>

                        <div className="button-finish" style={{ 
                            width: '100%', 
                            display: 'flex', 
                            flexDirection: 'row', 
                            justifyContent: 'center',}}>
                            <Button
                                width='296px'
                                height='50px'
                                value='VER PLANOS'
                                outline={false}
                                disabled={false}
                                onClick={() => RedirectPlan()}
                                loading={false}
                            />
                        </div>
                    </S.ContainerModalBlocked>
                </ModalGeneric> 
        </S.Container>
    );
}

export default withRouter(FrequentQuestions);